import { Injectable } from "@angular/core";
import {UrlBuilderService} from "@feature/common";
import {HttpClient} from "@angular/common/http";
import {MfsAllowLists} from "@mfs/default-dashboard/models/mfs-allow-lists.model";
import {Observable} from "rxjs";

@Injectable({ providedIn: 'root' })
export class MfsAllowListHttpDataService {

  constructor(private urlBuilder: UrlBuilderService,
              private http: HttpClient) { }

  public getForCurrentUser(): Observable<MfsAllowLists> {
    const url = this.urlBuilder.getUrl('mfs-allow-lists');
    return this.http.get<MfsAllowLists>(url);
  }
}
